<template>
  <span>{{ displayText }}</span>
</template>

<script>
import { mapState } from 'vuex'
import { maskValue, matchFieldType } from '@/utils/sensitive'

/**
 * 敏感信息展示组件
 * 用法：
 *   <sensitive-text :value="record.mobile" field="mobile" />
 *   <sensitive-text :value="record.idCard" type="idCard" />
 *
 * 说明：接口返回的数据已在 request 拦截器中统一脱敏，一般情况下直接使用 {{}} 即可；
 *      本组件用于非接口来源（本地拼接、缓存数据）的敏感字段，或需要单独指定类型的场景。
 */
export default {
  name: 'SensitiveText',
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    // 字段名，用于自动识别敏感类型（如 mobile、idCard、bankCardNo、businessLicense）
    field: {
      type: String,
      default: ''
    },
    // 直接指定类型：phone / idCard / bankCard / license / name / email / address
    type: {
      type: String,
      default: ''
    },
    // 展示模式：mask-脱敏 hide-隐藏，不传则取全局设置
    mode: {
      type: String,
      default: ''
    },
    // 值为空时的占位符
    placeholder: {
      type: String,
      default: '-'
    }
  },
  computed: {
    ...mapState({
      hidden: state => state.app.sensitiveHidden,
      globalMode: state => state.app.sensitiveMode
    }),
    displayText () {
      if (this.value === null || this.value === undefined || this.value === '') {
        return this.placeholder
      }
      if (!this.hidden) {
        return this.value
      }
      const type = this.type || matchFieldType(this.field)
      if (!type) {
        return this.value
      }
      return maskValue(this.value, type, this.mode || this.globalMode)
    }
  }
}
</script>
